<div class="ui-g-12">

  <div class="ui-g">
    <div *ngFor="let indicator of indicators" class="ui-g-12 ui-md-3 ui-sm-6">
      <app-infobox [pointData]="indicator.pointData" [penetration]="indicator.penetration" [t]="indicator.t" [options]="indicator.options"></app-infobox>
    </div>
  </div>

  <div class="campaigncharts" *ngIf="data != null">
    <div class="ui-g">
      <div class="ui-g-12 ui-md-6 ui-sm-12">
        <h2>{{ translations.indicenzaChartTitle }}</h2>
        <div class="chart-container">
          <chart [options]="incidenzaChart.options"
                 (load)="setChartInstance(incidenzaChart, $event.context)"></chart>
        </div>
      </div>

      <div class="ui-g-12 ui-md-6 ui-sm-12">
        <h2>{{ translations.scontrinoMedioChartTitle }}</h2>
        <div class="chart-container">
          <chart [options]="scontrinoMedioChart.options"
                 (load)="setChartInstance(scontrinoMedioChart, $event.context)"></chart>
        </div>
      </div>
    </div>
  </div>

  <p-dialog header="{{ 'common.error' | translate }}" [(visible)]="storeError" [width]="300" [modal]="true" [draggable]="false" [resizable]="false">
    <p>{{ selectOneError }}</p>
    <div class="ui-dialog-footer">
      <button pButton type="button" class="slim red-button" (click)="toogleErrorStoreDialog()" label="Ok"></button>
    </div>
  </p-dialog>

</div>



// WEBPACK FOOTER //
// ./src/app/views/store/store-customers/store-customers-loyalty/store-customers-loyalty.component.html